import { Point } from '../../../platform/geom/Point';
import { Rect } from '../../../platform/geom/Rect';

export interface Net {
    readonly parts: readonly NetPart[];
    readonly bounds: Rect;
    readonly visible: boolean;
}

export interface NetPart {
    readonly id: string;
    readonly type: string;
    readonly style: 'polyline' | 'node' | 'blob' | 'none';
    readonly verticies: readonly Point[];
    readonly data: Record<string, any>;
    test(vpt: Point): boolean;
}

export const NetPart = {

    border(id: string, type: string, verticies: readonly Point[]): NetPart {
        return {
            id,
            type,
            style: 'polyline',
            verticies,
            data: {},
            test: () => false,
        };
    }
};
